import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../../src/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { TextField, Button, Typography, Container , MenuItem, Select, FormControl,InputLabel} from "@mui/material";

const EditMovie = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [movie, setMovie] = useState({
    title: "",
    genre: "",
    director: "",
    duration: "",
    cast: [],
    crew: [],
    targetFunding: "",
    unitPrice: "",
  });

  useEffect(() => {
    const fetchMovie = async () => {
      try {
        const movieRef = doc(db, "movies", id);
        const movieSnap = await getDoc(movieRef);
        if (movieSnap.exists()) {
          setMovie(movieSnap.data());
        } else {
          console.error("Movie not found");
        }
      } catch (error) {
        console.error("Error fetching movie:", error);
      }
    };

    fetchMovie();
  }, [id]);

  const handleChange = (e) => {
    setMovie({ ...movie, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    try {
      const movieRef = doc(db, "movies", id);
      await updateDoc(movieRef, movie);
      console.log("Movie updated successfully"); // Debugging
  
      navigate("/admin/home/movies"); // Redirect back to admin page
    } catch (error) {
      console.error("Error updating movie:", error);
    }
  };
  

  return (
    <Container sx={{ backgroundColor: "#ffffff", padding: "24px", borderRadius: "8px" }}>

      <Typography variant="h4" gutterBottom>Edit Movie</Typography>
      <TextField fullWidth label="Title" name="title" value={movie.title} onChange={handleChange} margin="normal" />
      <FormControl fullWidth margin="normal">
        <InputLabel>Genre</InputLabel>
        <Select name="genre" value={movie.genre} onChange={handleChange}>
          <MenuItem value="">Select a genre</MenuItem>
          <MenuItem value="action">Action</MenuItem>
          <MenuItem value="comedy">Comedy</MenuItem>
          <MenuItem value="drama">Drama</MenuItem>
          <MenuItem value="sci-fi">Sci-Fi</MenuItem>
          <MenuItem value="horror">Horror</MenuItem>
          <MenuItem value="romance">Romance</MenuItem>
          <MenuItem value="thriller">Thriller</MenuItem>
          
        </Select>
      </FormControl>      <TextField fullWidth label="Director" name="director" value={movie.director} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Duration" name="duration" value={movie.duration} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Target Funding" name="targetFunding" value={movie.targetFunding} onChange={handleChange} margin="normal" />
      <TextField fullWidth label="Unit Price" name="unitPrice" value={movie.unitPrice} onChange={handleChange} margin="normal" />

      <Button variant="contained" color="primary" onClick={handleSave} style={{ marginTop: "16px" }}>
        Save
      </Button>
    </Container>
  );
};

export default EditMovie;
